import React from 'react';
import {useMask} from "@react-input/mask";
import useStyles from "./styles";

export const CardElement = (props) => {
    const classes = useStyles();
    const maskReference = useMask({
            mask: props.options.mask,
            replacement: {_: /\d/},
            onMask: (v) => {
                const {value, isValid } = v.detail;

                props.onChange({
                    value,
                    element: props.name,
                    completed: isValid,
                })
            }
        }
    );

    const value = props.value.value || '';

    return (
        <div className={classes.customCardInput}>
          <input
              className={`${props.options.className || ''} ${classes.customCardInputElement}`}
              ref={maskReference}
              onChange={(e) => {}}
              placeholder={props.options.placeholder}
              value={value}
          />
        </div>
      );
}
